import { getFunctions, httpsCallable } from "firebase/functions";
import { db } from "services/firebase";

const functions = getFunctions();
const createCallable = httpsCallable(functions, "createInterpreterRequest");
const updateCallable = httpsCallable(functions, "updateInterpreterRequest");

export async function createInterpreterRequest(payload) {
  const result = await createCallable(payload);
  return result?.data;
}

export async function updateInterpreterRequest({ requestId, action }) {
  const result = await updateCallable({ requestId, action });
  return result?.data;
}

/**
 * Live open + acknowledged requests for one facility, newest first.
 */
export function subscribeFacilityInterpreterRequests(facilityId, onChange, onError) {
  if (!facilityId) {
    onChange([]);
    return () => {};
  }
  return db
    .collection("interpreterRequests")
    .where("facilityId", "==", facilityId)
    .where("status", "in", ["open", "acknowledged"])
    .onSnapshot(
      (snap) => {
        const rows = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        rows.sort((a, b) => {
          const aMs = a.requestedAt?.toMillis?.() || 0;
          const bMs = b.requestedAt?.toMillis?.() || 0;
          return bMs - aMs;
        });
        onChange(rows);
      },
      (err) => onError?.(err),
    );
}

/**
 * Subscribe across multiple facility ids (union of snapshots).
 */
export function subscribeInterpreterRequestsForFacilities(
  facilityIds,
  onChange,
  onError,
) {
  const ids = (facilityIds || []).filter(Boolean);
  if (ids.length === 0) {
    onChange([]);
    return () => {};
  }
  const byFacility = new Map();
  const unsubs = ids.map((facilityId) =>
    subscribeFacilityInterpreterRequests(
      facilityId,
      (rows) => {
        byFacility.set(facilityId, rows);
        const merged = [];
        byFacility.forEach((list) => merged.push(...list));
        merged.sort((a, b) => {
          const aMs = a.requestedAt?.toMillis?.() || 0;
          const bMs = b.requestedAt?.toMillis?.() || 0;
          return bMs - aMs;
        });
        onChange(merged);
      },
      onError,
    ),
  );
  return () => unsubs.forEach((u) => u());
}
